export const useMediaQuery = (query: string) => window.matchMedia(`(${query})`).matches;
